import request from '@/utils/request'

export function getUserMembership(params) {
  return request({
    url: '/user-memberships',
    method: 'get',
    params
  })
}

export function getMyUserMembership(params) {
  return request({
    url: '/user-memberships/my',
    method: 'get',
    params
  })
}

export function upsertUserMembership(data) {
  return request({
    url: '/user-memberships/upsert',
    method: 'post',
    data
  })
}

export function batchUserMemberships(data) {
  return request({
    url: '/user-memberships/batch',
    method: 'post',
    data
  })
}
